export default __webpack_public_path__ + "static/media/cadetIcon.eadfd5dc.png";